import header from "./paar-bei-steuerberatung.jpg";
import section1 from "./tabelle-durchrechnen.webp";
import section2 from "./Taschenrechner-Mensch-Kalkulation.webp";
import section3 from "./app-steuer-rueckerstattung.webp";
import section4 from "./haussteuer-wird-untersucht.jpg";
import section6 from "./steuer-wird-durchgerechnet.jpg";
import section5 from "./steuerberatungsgespraech.jpg";
import section7 from "./steuerpapiere-mit-geld.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
